import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loading from "../../Components/Common/Loading";
import InputText from "../../Components/sectioninput/formelement/InputText";
import {
  getContactItem,
  // sendEmail,
  setContactViewed,
} from "../../REDUX/actions/contact";
import moment from "moment";
// import CustomButton from "../../Components/Common/CustomButton";

const ContactItemView = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const { contactLoading, contactItem } = useSelector(
    (state) => state.contactsReducer
  );

  useEffect(() => {
    dispatch(getContactItem(params.id));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (contactItem) {
      if (!contactItem.attributes.viewedBy?.includes(user.firstName)) {
        dispatch(
          setContactViewed(
            contactItem.id,
            `${contactItem.attributes.viewedBy || "Vue par"}, ${
              user.firstName
            } le ${moment().format("MM-DD-YYYY")}`
          )
        );
      }
    } // eslint-disable-next-line
  }, [contactItem]);

  // const handleMailing = () => {
  //   dispatch(sendEmail(contactItem.id));
  // };

  return contactLoading || !contactItem ? (
    <Loading />
  ) : (
    <div className="container-fluid bg-white shadowed p-5 rounded-10 ">
      <div className="row f24 align-items-center mb-2">Donnée du client</div>
      <div className="row f14 align-items-center mb-5">
        {contactItem.attributes.viewedBy?.replace(/,/, " ")}
      </div>
      <div className="row">
        <div className="col-6">
          <InputText
            labelinput={"Prénom"}
            readOnly
            value={contactItem.attributes.firstName || "Non renseigné"}
            flag={false}
          />
          <InputText
            labelinput={"Nom"}
            readOnly
            value={contactItem.attributes.lastName || "Non renseigné"}
            flag={false}
          />
          <InputText
            labelinput={"E-mail"}
            readOnly
            value={contactItem.attributes.email || "Non renseigné"}
            flag={false}
          />
          <InputText
            labelinput={"Téléphone"}
            readOnly
            value={contactItem.attributes.phoneNumber || "Non renseigné"}
            flag={false}
          />
          <InputText
            labelinput={"Adresse"}
            readOnly
            value={contactItem.attributes.adresse || "Non renseigné"}
            flag={false}
          />
          <InputText
            labelinput={"Code Postal"}
            readOnly
            value={contactItem.attributes.postalCode || "Non renseigné"}
            flag={false}
          />
          <InputText
            labelinput={"Ville"}
            readOnly
            value={contactItem.attributes.city || "Non renseigné"}
            flag={false}
          />
        </div>
        <div className="col-6">
          <InputText
            labelinput={"Type de la demande"}
            readOnly
            value={contactItem.attributes.type || "Non renseigné"}
            flag={false}
          />
          {contactItem.attributes.information ? (
            <InputText
              labelinput={"Information demandé"}
              readOnly
              value={contactItem.attributes.label}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.interestedIn ? (
            <InputText
              labelinput={"Gamme"}
              readOnly
              value={contactItem.attributes.interestedIn}
              flag={false}
            />
          ) : null}
          ²
          {contactItem.attributes.buyPeriod ? (
            <InputText
              labelinput={"Période d'achat potentielle"}
              readOnly
              value={contactItem.attributes.buyPeriod}
              flag={false}
            />
          ) : null}
          {contactItem.attributes.message ? (
            <>
              <label className="f16 text-start w-100 mb-1">Message</label>
              <textarea
                className="styleInput readOnlyArea w-100 rounded-3"
                readOnly
                value={contactItem.attributes.message}
              />
            </>
          ) : null}
          {contactItem.attributes.file_url ? (
            <>
              <label className="f16 text-start w-100 mb-1">Pièce jointe</label>
              <div className="text-start">
                <a
                  href={contactItem.attributes.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contactItem.attributes.file_name || "Voir le document"}
                </a>
              </div>
            </>
          ) : null}
          {/* <div className="mt-5"></div> <CustomButton buttonText={"Transmettre"} callBack={handleMailing}></CustomButton> */}
        </div>
      </div>
    </div>
  );
};

export default ContactItemView;
